const manageClassName = (element: string, className: string, action: 'add' | 'remove' | 'toggle' = 'add'): void => {
  const validActions: Array<'add' | 'remove' | 'toggle'> = ['add', 'remove', 'toggle']
  if (validActions.includes(action)) {
    document.querySelectorAll(element).forEach(iframe => {
      iframe.parentElement?.classList[action]?.(className)
    })
  }
}

export default manageClassName
